// 系统
import { $post, $get, $delete, $patch} from '@/utils/http'
import Service from './Service'
import Storage from '@/utils/storage'

// 接口集合
const _url = {
    // 获取子系统列表
    getList: `/ucenter/v2/project/system/all`,
    // 获取单个子系统信息
    getInfo: `/ucenter/v2/project/system`,       //获取单个子系统信息
    // 增加子系统
    add: '/ucenter/v2/project/system',
    // 删除子系统
    detele: '/ucenter/v2/project/system',
    // 编辑子系统
    edit: '/ucenter/v2/project/system',
}

//获取项目子系统列表
Service.getProjectSystemList = async function (params) {
	let request = {}
	request['project_id'] = Service.getProjectId()
    let data = await $get(_url.getList, request);
    return Service.handleCommonError(data)
	
}
//获取售后服务信息
Service.getAftersales = async function (params) {
	let request = {}
	request['oid'] = Service.getProjectSystemId()
    let data = await $get("/ucenter/v2/project/system/info", request);
    return Service.handleCommonError(data)
	
}
//获取指定项目子系统信息
Service.getProjectSystemInfo = async function () {
    let request = {}
    // 项目Id
	// request['oid'] = params.oid;
    request['assigned_system_id'] = Service.getProjectSystemId();
    if (!request['assigned_system_id']) return;
    
    // 如果本地有缓存项目子系统信息，直接返回
    if (Storage.get('ProjectSystemInfo')){
        return Storage.get('ProjectSystemInfo').projectsystemInfo;
    }
    let data = await $get(_url.getInfo, request);
    return Service.handleCommonError(data)
}


//添加项目子系统
Service.addProjectSystem= async function (params) {
    let request = {}
    // 所属项目ID
    request['project_id'] = params.project_id;
    // 系统类型ID
    request['sys_type_id'] = params.sys_type_id;
    // 项目子系统名称
    request['project_system_name'] = params.project_system_name;
    // 备注
    request['description'] = params.description;
	// 设备信息
	request['terminal_info'] = JSON.stringify(params.terminal_info);
    let data = await $post(_url.add, request);
    return Service.handleCommonError(data)
}
//编辑项目子系统
Service.editProjectSystem = async function (params) {
    let request = {}
    // 项目子系统名称
	request['oid']=params.oid;
    request['project_system_name'] = params.project_system_name;
    // 备注
    request['description'] = params.description;

    let data = await $patch(_url.edit, request);
    return Service.handleCommonError(data)
 // var formData = new FormData();
 // formData.append("project_system_name", params.project_system_name);
 // formData.append("description", params.description);
 
 // let data = await $patch(_url.edit + '', formData);
 // return Service.handleCommonError(data)
}
//删除项目子系统
Service.deleteProjectSystem = async function (params) {
    // let request = {}
    // // 	项目子系统ID
    // request['oid'] = params.oid;
    // let data = await $delete(_url.detele, request);
    
	
    var formData = new FormData();
    formData.append("oid", params.oid);

    let data = await $delete(_url.detele + '', formData);
	return Service.handleCommonError(data)
	
}
